export default __webpack_public_path__ + "static/media/hygiene.00ffa034.svg";